module.exports = __webpack_public_path__ + "images/help/cloud-small@2x-8659fc3ef02fdbeccbcb8bb48bc40f6a.png";